import { useState, useEffect } from 'react';

export interface MobileInfo {
  isMobile: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isStandalone: boolean;
  userAgent: string;
  screenSize: {
    width: number;
    height: number;
  };
}

export function useMobileDetection(): MobileInfo {
  const [mobileInfo, setMobileInfo] = useState<MobileInfo>({
    isMobile: false,
    isIOS: false,
    isAndroid: false,
    isStandalone: false,
    userAgent: '',
    screenSize: {
      width: 0,
      height: 0
    }
  });

  useEffect(() => {
    const detectMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      // Detecção específica de sistemas
      const isIOS = /iphone|ipad|ipod/i.test(userAgent) && !('MSStream' in window);
      const isAndroid = /android/i.test(userAgent);

      // Detecção geral de mobile
      const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(userAgent);
      const isTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth <= 768;

      const isMobile = isMobileUserAgent || (isTouchScreen && isSmallScreen) || isIOS || isAndroid;

      // Detecção de PWA/standalone
      const isStandalone = (window.navigator as any).standalone === true ||
                          window.matchMedia('(display-mode: standalone)').matches;

      setMobileInfo({
        isMobile,
        isIOS,
        isAndroid,
        isStandalone,
        userAgent,
        screenSize: {
          width: window.innerWidth,
          height: window.innerHeight
        }
      });
    };

    // Detecção inicial
    detectMobile();

    // Re-detectar em mudanças de tamanho
    const handleResize = () => {
      detectMobile();
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return mobileInfo;
}